import type {Context} from '../types';

// Strip out unneeded preserve3d: false
export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {data = {}} = jsonNode;

  return {
    needed: data && data.preserve3d === false,
    logData: {
      msg: 'Node with false data.preserve3d',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      // eslint-disable-next-line webflow/no-delete
      delete data.preserve3d;
    },
  };
};
